import { useEffect, useState } from "react";
import styled from "@emotion/styled";
//import { useWindowSize } from "@reactuses/core";
import { GetPastHistory } from "../../types/types";
import theme from "../../theme";
import { ModalLayout } from "../../components/common/ModalLayout";
import Spinner from "../../components/spinner";
import { Button } from "../../components/common/Button";
import useGetDetectPastDetail from "../../hooks/useGetDetectPastDetail";
import InfoContent from "./infoContent";
import { MarkerMap } from "./MarkerMap";
import { useI18n } from "../../locales";

const { md/*, sm */} = theme.screen;

const EventDetailModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  seq: number;
  setDetailData: any;
  detailData?: GetPastHistory;
}> = (props) => {
  const { t } = useI18n();
  const {
    open,
    onPressNo,
    seq,
    setDetailData,
  } = props;
  //const { width } = useWindowSize();
  const { data, isLoading } = useGetDetectPastDetail(
    { seq },
    { fetch: open }
  );
  const [mapLevel, setMapLevel] = useState(5);

  useEffect(() => {
    if (data) {
      setDetailData(data);
    }
  }, [data, setDetailData]);

    return (
      <ModalLayout
        open={open}
        onClose={onPressNo}
        width="1300px"
        title={t.history.detectionDetailView}
      >
        {isLoading && <Spinner />}
        <MainWrapper>
          {data && <InfoContent 
            data={data} 
          />}
          {data && <MarkerMap 
            latitude={data.latitude}
            longitude={data.longitude}
            isLoading={isLoading}
            registeredAt={data.registered_at}
            mapLevel={mapLevel}
            setMapLevel={setMapLevel}
            eventName={data.code_name}
          />}
        </MainWrapper>

        <BtnWrapper>
          <Button
            bgColor={theme.color.neutral_400}
            onClick={onPressNo}
            hoverColor={theme.color.neutral_500}
          >
            {t.common.close}
          </Button>
        </BtnWrapper>
      </ModalLayout>
    );
};

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }

  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }

`;

const MainWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  @media (max-width: ${md}px) {
    flex-wrap: wrap
  }
`;

export default EventDetailModal;